import { ChatServiceType } from '@nimbus-global/features/chat/models/chat.model';
import { ChatApiRoutes } from '@nimbus-global/features/chat/services/chat.api-routes.const';
import { ChatUrlParams } from '@nimbus-global/features/chat/models/chat-service.model';

const UserApiRoutes = {
  [ChatServiceType.Whatsapp]: 'TwilioService',
  [ChatServiceType.Sms]: 'TwilioService',
  [ChatServiceType.Rcs]: 'TwilioService',
};

export function buildChatApiUrl(
  type: ChatServiceType,
  method: 'Get' | 'Post' | 'LastIndexRead' | 'SaveDraft' | 'MediaPolicy' | 'Media',
  params: ChatUrlParams,
): string {
  return ChatApiRoutes[UserApiRoutes[type]]?.[method](...Object.values(params));
}
